// WikiConnector 接口
import { get, post } from '~/assets/js/api/methods.js'

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'https://api-gw.interface003.com'
  : 'https://api-gw.interface003.com'

export default axios => ({
  // 获取/创建用户密钥和证书（首次调用自动创建用户）
  getCredentials: (params = {}) => get(axios, `${BASE_URL}/api/mtbridge/user/credentials`, params),
  // 获取用户信息
  getUserProfile: (params = {}) => get(axios, `${BASE_URL}/api/mtbridge/user/profile`, params),
  // 重新生成密钥
  regenerateKey: (params = {}) => post(axios, `${BASE_URL}/api/mtbridge/user/regenerate-key`, null, {}, { params }),
  // 设置离线缓冲开关
  setOfflineBuffer: (params = {}, data = {}) => axios({ url: `${BASE_URL}/api/mtbridge/user/offline-buffer`, method: 'put', params, data }),
  // 获取证书列表
  getLicenses: (params = {}) => get(axios, `${BASE_URL}/api/mtbridge/licenses`, params),
  // 获取指定证书下的连接详情
  getLicenseConnections: (licenseId, params = {}) => get(axios, `${BASE_URL}/api/mtbridge/licenses/${licenseId}/connections`, params),
  // 信号列表（分页+筛选）
  getSignals: (params = {}) => get(axios, `${BASE_URL}/api/mtbridge/signals`, params),
  // 信号统计概览
  getStatsOverview: (params = {}) => get(axios, `${BASE_URL}/api/mtbridge/stats/overview`, params)
})
